/**
 * Per-section WYSIWYG scope IDs prevent injected <style> blocks from colliding
 * when multiple sections use the same content class (e.g. .about-section-content).
 */
export const getWysiwygScopeId = (sectionId: string | number, prefix: string): string =>
  `${prefix}-wysiwyg-${sectionId}`

export const getWysiwygScopeSelector = (sectionId: string | number, prefix: string): string =>
  `#${getWysiwygScopeId(sectionId, prefix)}`
